<template>
  <div class="activity-list-item row">
    <div class="col-2 col-sm-2">
        <activity-icon :id="activity.icon_id"></activity-icon>
        <span style="margin-left: 5px">
            {{ activity.activity }}
        </span>
    </div>
    <div class="col-3 col-sm-2">
        <div style="margin-top: 7px; padding-left: 5px; padding-right: 5px; display: inline-block; border-radius: 12px; background-color: #8e70d3; border: 2px solid #765cae; color: white; font-size: 12px">
        {{ activity.start_time.substr(0, 5) }}
        <span v-if="activity.end_time">
        <span class="d-none d-sm-inline">
            -
        </span>
        {{ activity.end_time.substr(0, 5) }}
        </span>
        </div>
    </div>
    <div class="col-12 col-sm-6">
        <p style="margin-top: 5px; margin-bottom: 12px">
            <span style="white-space: pre-line" v-if="activity.text">{{ activity.text }}</span>
        </p>
    </div>
    <div class="col-12 col-sm-2 d-none d-sm-inline-block text-end">
        <span v-if="showEdit && activity.icon_id != 9" v-on:click="onEdit(activity)">
            <icon name="edit"></icon>
        </span>
        <span v-if="showDelete && activity.icon_id != 9" v-on:click="onDelete(activity)">
            <icon name="delete" class="ms-2"></icon>
        </span>
    </div>
    <div v-if="divider === true" class="col-12">
        <hr>
    </div>
  </div>
</template>

<script>
import ActivityIcon from '@/components/Activity-Icon'
import Icon from '@/components/Icon'
export default {
  name: 'activity-list-item',
  props: ['activity', 'divider', 'showDelete', 'showEdit'],
  components: {
    ActivityIcon,
    Icon
  },
  methods: {
    onDelete (activity) {
      this.$emit('onDelete', activity)
    },
    onEdit (activity) {
      this.$emit('onEdit', activity)
    }
  }
}
</script>

<style scoped>
  hr {
    margin-top: 5px;
    margin-bottom: 10px;
  }
</style>
